import { useEffect } from 'react';
import DriversDataTable from './DriversDataTable/DriversDataTable';

function Drives() {

  // #region templates

  const viewTemplate = (
    <>
      <article>
        <section>
          <h1>
            Conductores
          </h1>
        </section>
        <section>
          <DriversDataTable />
        </section>
      </article>
    </>
  );

  // #endregion

  useEffect(() => {
    setTimeout(() => {
      window.scrollTo(0, 0);
    }, 100);
  }, []);

  return (
    <>
      {viewTemplate}
    </>
  );
}

export default Drives;